import { Component, Input } from '@angular/core';

import { MonitoringResultUser } from '@classes/monitoring/monitoring-result-user';

@Component({
  selector: 'app-monitoring-results-users',
  templateUrl: './monitoring-results-users.component.html',
  styleUrls: ['./monitoring-results-users.component.scss']
})
export class MonitoringResultsUsersComponent {

    @Input() users: MonitoringResultUser[] = [];

    constructor() { }

}
